import type { FaireProductEntity } from "../../entity_types/product";

export const p_nstqjgvs38: FaireProductEntity = {
  token: "p_nstqjgvs38",
  type: "product",
  name: "Frontier Co-op Red Raspberry Leaf, Certified Organic",
  brandToken: "b_5ashuqcsm4",
  brandName: "Frontier Co-op",
  imageUrl:
    "https://cdn.faire.com/fastly/ce9e4e2db4eb17e0802c9e54c727ea9d4b9648c1cae45f0a228ccb02bebafcc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6eaacb18d04bd5416580b79259f5a97568c4e94e6af333c0c7922c893d132744.jpeg",
    "https://cdn.faire.com/fastly/cef4c987e3e06e43a0e47abf88936a1a6b1da9b67df174308bdd2b2a8c0c99f3.jpeg",
    "https://cdn.faire.com/fastly/64f3be53ccc465138ad86f8f28a330be075287498203922483658d2bac2025e3.jpeg",
    "https://cdn.faire.com/fastly/15087518fe6f4c38eb0b8cc8cd34a69568fd52b19cd1151584a4b7ec76857493.jpeg",
    "https://cdn.faire.com/fastly/f4d04e42a24b9dd58da95adb67ac0e44beb1bad5b8fcf452012ce5794314cfae.jpeg",
    "https://cdn.faire.com/fastly/1bd41be0c96daf909f7f2c0fce6ffac9fab9e5c5726b28dde76094ad903033e7.jpeg",
  ],
  priceDollars: 6.29,
  description:
    "Frontier Co-op® Organic Red Raspberry Leaf (Rubus idaeus L.) is a caffeine-free, earthy herb commonly used in herbal teas and DIY body care products. Despite its name, it doesn't taste like raspberries, offering a vegetal flavor with a slight bitterness. The leaves have a bolder, sweeter profile compared to other tea leaves, with tannins that add a subtle acidic note, making them perfect for blending with other herbs to create robust, flavorful beverages.\n\n•\t1.48 oz. \n•\tForm – Cut & Sifted\n•\tBotanical Name – Rubus idaeus L.\n•\tCertified Organic\n•\tCertified Kosher\n•\tNon-ETO\n•\tNon-Irradiated\n•\tNo Artificial Ingredients",
  tags: [],
  msrpDollars: 9.55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:55.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
